
import React from "react";
import { Clock } from "lucide-react"; // Change Watch to Clock

interface CourseMetaProps {
  level?: string;
  duration?: string;
}

const CourseMeta = ({ level, duration }: CourseMetaProps) => (
  <div className="flex flex-wrap gap-3 mb-3 items-center">
    {level && level !== "Algaja" && (
      <span className="bg-kaija-peach/60 rounded px-3 py-1 text-sm font-medium text-kaija-accent">
        {level}
      </span>
    )}
    {duration && (
      <span className="flex items-center gap-2 bg-kaija-slate/10 rounded px-3 py-1 text-sm font-medium">
        <Clock className="w-4 h-4 text-kaija-accent" />
        <span>{duration}</span>
      </span>
    )}
  </div>
);

export default CourseMeta;
